import {connect} from 'react-redux';

import {ContactOrAccountDetailsPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapDispatchToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AccountModel} from '../../../../models/api/accountModel';
import {domainsUpdatedAction} from '../../../../store/panels/accounts/accountDetailsPanelActions';
import {EmailDomainDropdown} from './emailDomainDropdown';

/*
 * Props.
 */

interface EmailDomainDropdownContainerProps {
  panelId?: ContactOrAccountDetailsPanelId;
  account: AccountModel;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<EmailDomainDropdownContainerProps>()((props) => ({
  updateDomains: (updatedDomains: ReadonlyArray<string>) =>
    domainsUpdatedAction(props.panelId, props.account, updatedDomains),
}));

export const EmailDomainDropdownContainer = connect(null, mapDispatchToProps)(EmailDomainDropdown);
